/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { keyCode } from '@bingads-webui/keycode';

import { getCellSectionDecoratorStyle } from '../styles/tiles-grid-cell-selection-decorator-style';

const checkboxStyles = ({
  checkbox: {
    borderWidth: 2,
    borderColor: 'white',
    outline: 'black solid 1px',
    // make the checkbox is on top of the overlay of cells
    zIndex: 2,
  },
});

const CellSelectionDecorator = ({
  item, selected, onClick, children, classes, ariaLabel, isFocused,
}) => {
  const onClickFunc = (event) => {
    if (onClick) {
      onClick({ item, selected });
    }
    if (event.stopPropagation) { event.stopPropagation(); }
    if (event.preventDefault) { event.preventDefault(); }
  };

  const onKeyDown = (event) => {
    if (event.keyCode === keyCode.Enter) {
      onClickFunc();
    }
  };

  return (
    <div className={classnames(classes.cellSelectionDecoratorWrapper, 'grid-cell-selection-decorator-wrapper', selected && classes.selectedStateWrapper, selected ? 'selectedStateWrapper' : '')}>
      <div
        className={classnames(classes.cellSelectionDecorator, 'grid-cell-selection-decorator', selected && classes.selectedState, selected ? 'selectedState' : '')}
        onClick={onClickFunc}
        role="button"
        tabIndex={0}
        onKeyDown={onKeyDown}
      >
        {children}
      </div>
      <div
        className={classnames('selected-checkbox', isFocused && 'visible-checkbox')}
        onClick={onClickFunc}
      >
        <Checkbox
          checked={selected}
          styles={checkboxStyles}
          ariaLabel={ariaLabel}
        />
      </div>
    </div>
  );
};

CellSelectionDecorator.propTypes = {
  item: PropTypes.shape({}).isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    cellSelectionDecorator: PropTypes.string,
    cellSelectionDecoratorWrapper: PropTypes.string,
    selectedState: PropTypes.string,
    selectedStateWrapper: PropTypes.string,
  }).isRequired,
  ariaLabel: PropTypes.string,
  isFocused: PropTypes.bool,
};

CellSelectionDecorator.defaultProps = {
  onClick: undefined,
  ariaLabel: '',
  isFocused: false,
};

export const TilesGridCellSelectionDecorator
  = withDefaultStyles(CellSelectionDecorator, getCellSectionDecoratorStyle);
